import Button from '@/components/UI/Button';
import { HookForm } from '@/components/UI/HookForm/Form';
import { HookFileInput } from '@/components/UI/HookForm/Form/File';
import { HookFormProvider } from '@/components/UI/HookForm/Provider';
import type { ValidationFunction } from '@/components/UI/HookForm/types';
import Modal from '@/components/UI/Modal';
import { useCSVParser } from '@/store/Context/CSVParserContext';
import type { FormValues } from './types';

export interface IUploadModalProps {
  onHide: () => void;
}

export const UploadModal = (props: IUploadModalProps) => {
  const { onHide } = props;
  const { parseCSV } = useCSVParser();

  const handleSubmit = async (values: FormValues) => {
    try {
      await parseCSV(values);
      onHide();
    } catch (err) {
      console.log(err);
    }
  };
  const validateCsv: ValidationFunction = (value: any) => {
    if (value) {
      const file = (value as File[])[0];
      const extension = file.name.split('.').pop();
      if (extension !== 'csv') {
        return 'CSV File is required.';
      }
      return undefined;
    }
    return undefined;
  };
  return (
    <Modal>
      <h3 className='mb-4'>Import TDM from CSV</h3>
      <HookFormProvider mode='all' reValidateMode='onChange'>
        <HookForm onSubmit={handleSubmit} className='space-y-4'>
          <HookFileInput name='task' accept='.csv' label='Task' validate={validateCsv} />
          <HookFileInput name='deliverable' accept='.csv' label='Deliverable' validate={validateCsv} />
          <HookFileInput name='milestone' accept='.csv' label='Milestone' validate={validateCsv} />
          <div className='flex gap-4 pt-5 justify-end'>
            <Button label='Cancel' btnStyle='neutral' onClick={onHide} />
            <Button label='Upload' btnStyle='primary' type='submit' />
          </div>
        </HookForm>
      </HookFormProvider>
    </Modal>
  );
};
